import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { IFormFieldNumber } from '.';
import { NumberDisplay } from './NumberDisplay';

interface IProps {
  value?: number;
  previousValue?: number | null;
  onClose: () => void;
  config: IFormFieldNumber;
}

export const NumberDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: IProps) => {
  const prevZeroState = !previousValue;
  const currentZeroState = !value;
  const label = config.params.labels.main;

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No {label} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        {prevZeroState ? zeroState : <NumberDisplay value={previousValue} />}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        {currentZeroState ? zeroState : <NumberDisplay value={value} />}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
